import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const BrandPhilosophyPage = lazy(() => import('../pages/brand-philosophy/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const MouthBreathingCarePage = lazy(() => import('../pages/products/mouth-breathing-care/page'));
const NasalCarePage = lazy(() => import('../pages/products/nasal-care/page'));
const OralCarePage = lazy(() => import('../pages/products/oral-care/page'));
const SleepNoiseControlPage = lazy(() => import('../pages/products/sleep-noise-control/page'));
const WhereToBuyPage = lazy(() => import('../pages/where-to-buy/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const JournalPage = lazy(() => import('../pages/journal/page'));
const GermanMedicalOriginPage = lazy(() => import('../pages/german-medical-origin/page'));
const ScienceDesignPage = lazy(() => import('../pages/science-design/page'));
const QualityManufacturingPage = lazy(() => import('../pages/quality-manufacturing/page'));
const TrustCompliancePage = lazy(() => import('../pages/trust-compliance/page'));
const BodyAestheticsResearchPage = lazy(() => import('../pages/body-aesthetics-research/page'));
const CustomerStoriesPage = lazy(() => import('../pages/customer-stories/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/brand-philosophy',
    element: <BrandPhilosophyPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/products/mouth-breathing-care',
    element: <MouthBreathingCarePage />,
  },
  {
    path: '/products/nasal-care',
    element: <NasalCarePage />,
  },
  {
    path: '/products/oral-care',
    element: <OralCarePage />,
  },
  {
    path: '/products/sleep-noise-control',
    element: <SleepNoiseControlPage />,
  },
  {
    path: '/where-to-buy',
    element: <WhereToBuyPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/journal',
    element: <JournalPage />,
  },
  {
    path: '/german-medical-origin',
    element: <GermanMedicalOriginPage />,
  },
  {
    path: '/science-design',
    element: <ScienceDesignPage />,
  },
  {
    path: '/quality-manufacturing',
    element: <QualityManufacturingPage />,
  },
  {
    path: '/trust-compliance',
    element: <TrustCompliancePage />,
  },
  {
    path: '/body-aesthetics-research',
    element: <BodyAestheticsResearchPage />,
  },
  {
    path: '/customer-stories',
    element: <CustomerStoriesPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
